import { utils } from '@febos-io/common';

export const changePasswordSchema = utils.validator.object().shape({
  email: utils.validator.string()
    .required('This field is required')
    .email('This field is invalid')
});

export default changePasswordSchema;
